class RegisterForm {
  constructor() {
    this.init();
  }

  init() {
    const registerForms = document.querySelectorAll('[js-register-acount]');
    if (!registerForms.length) return;

    registerForms.forEach((container) => {
      this.applySignupSourceTag(container);
      this.colectCustomerBirthday(container);
      this.initFormValidation(container);
      this.initPasswordInputListener(container);
    });
  }

  applySignupSourceTag(container) {
    const customerTagInput = container.querySelector('input[name="customer[tags]"]');
    if (!customerTagInput) return;

    const params = new URLSearchParams(window.location.search);
    const source = params.get('signup_source');
    if (source === 'merrick_qr') {
      customerTagInput.dataset.signupSourceTag = 'Merrick QR';
      customerTagInput.value = 'Merrick QR';
    }
  }

  buildTagValue(customerTagInput, birthdayValue) {
    const tags = [];
    const sourceTag = customerTagInput.dataset.signupSourceTag;
    if (sourceTag) tags.push(sourceTag);
    if (birthdayValue) tags.push(`customerBirthday--${birthdayValue}`);
    return tags.join(', ');
  }

  initFormValidation(container) {
    const form = container.querySelector('form');
    if (!form) return;

    const passwordInput = form.querySelector('#RegisterForm-password');
    const confirmPasswordInput = form.querySelector('#RegisterForm-password-confirmation');
    form.addEventListener('submit', (event) => {
      if (passwordInput && confirmPasswordInput && passwordInput.value !== confirmPasswordInput.value) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        const fieldWrapper = confirmPasswordInput.parentElement;
        let errorMsg = fieldWrapper.parentElement.querySelector('.password-mismatch-error');

        if (!errorMsg) {
          errorMsg = document.createElement('span');
          errorMsg.className = 'form__message password-mismatch-error';
          errorMsg.innerHTML = `${this.errorSVG()} Passwords do not match.`;
          fieldWrapper.parentElement.insertBefore(errorMsg, fieldWrapper.nextSibling);
        }

        confirmPasswordInput.setAttribute('aria-invalid', 'true');
        confirmPasswordInput.focus();
        return false;
      }
    });
  }

  initPasswordInputListener(container) {
    const form = container.querySelector('form');
    if (!form) return;

    const passwordInput = form.querySelector('#RegisterForm-password');
    const confirmPasswordInput = form.querySelector('#RegisterForm-password-confirmation');

    if (!passwordInput || !confirmPasswordInput) return;

    confirmPasswordInput.addEventListener('input', () => {
      const errorMsg = confirmPasswordInput.parentElement.parentElement.querySelector('.password-mismatch-error');
      if (errorMsg && passwordInput.value === confirmPasswordInput.value) {
        errorMsg.remove();
        confirmPasswordInput.removeAttribute('aria-invalid');
      }
    });
  }

  colectCustomerBirthday(container) {
    const customerTagInput = container.querySelector('input[name="customer[tags]');
    const customerDateInput = container.querySelector('[data-birthday-input]');
    const form = container.querySelector('form');
    if (customerTagInput && customerDateInput) {
      customerDateInput.addEventListener('input', (event) => {
        this.formatBirthday(event);
      });
      customerDateInput.addEventListener('change', (event) => {
        event.preventDefault();
        event.stopPropagation();
        if(this.validateBirthdayInput(form, customerDateInput)) {
          customerTagInput.value = this.buildTagValue(customerTagInput, customerDateInput.value);
        }
      });

      customerDateInput.addEventListener('keydown', (event) => {
         if(event.code === 'Enter') {
          if(!this.validateBirthdayInput(form, customerDateInput)) {
          event.preventDefault()
          event.stopPropagation();
          } else {
            customerTagInput.value = this.buildTagValue(customerTagInput, customerDateInput.value);
          }
         }
      });
  
    }
  }

  formatBirthday(event) {
    if (!event) return;
    let inputValue = event.target.value.replace(/[^\d]/g, '');

    if (inputValue.length >= 3) {
      let month = inputValue.slice(0, 2);
      let day = inputValue.slice(2, 4);
      inputValue = `${month}/${day}`;
    }

    event.target.value = inputValue.slice(0, 5);
  }

  validateBirthdayInput(container, input) {
    const birthdayError = container.querySelector('[data-birthday-error]');
    let valid = true;
    const calendar = {
      '01': {
        days: 31,
        name: 'January',
      },
      '02': {
        days: 29,
        name: 'February',
      },
      '03': {
        days: 31,
        name: 'March',
      },
      '04': {
        days: 30,
        name: 'April',
      },
      '05': {
        days: 31,
        name: 'May',
      },
      '06': {
        days: 30,
        name: 'June',
      },
      '07': {
        days: 31,
        name: 'July',
      },
      '08': {
        days: 31,
        name: 'August',
      },
      '09': {
        days: 30,
        name: 'Sptember',
      },
      '10': {
        days: 31,
        name: 'October',
      },
      '11': {
        days: 30,
        name: 'November',
      },
      '12': {
        days: 31,
        name: 'December',
      },
    };
    const errorStrings = JSON.parse(window.atob(birthdayError.dataset.errorString));
    birthdayError.innerHTML = '';
    birthdayError.style.display = 'none';
    input.removeAttribute('aria-invalid');

    const regex = /^(\d{2})\/(\d{2})$/;
    const match = input.value.match(regex);

    if (!match) {
      birthdayError.innerHTML = `${this.errorSVG()} ${errorStrings.wrong_format}`;
      birthdayError.removeAttribute('style');
      input.setAttribute('aria-invalid', 'true');
      input.focus();
      valid = false;
    } else {
      const month = match[1];
      const day = Number(match[2]);
      const daysInMonth = calendar[month];
      if (!daysInMonth) {
        birthdayError.innerHTML = `${this.errorSVG()} ${errorStrings.moth_error}`;
        birthdayError.removeAttribute('style');
        input.setAttribute('aria-invalid', 'true');
        input.focus();
        valid = false;
      } else if (day < 1 || day > daysInMonth.days) {
        birthdayError.innerHTML = `${this.errorSVG()} ${errorStrings.day_error.replace('[[days_value]]', calendar[month].days).replace('[[month_value]]', calendar[month].name)}`;
        birthdayError.removeAttribute('style');
        input.setAttribute('aria-invalid', 'true');
        input.focus();
        valid = false;
      }
    }
    return valid;
  }

  errorSVG() {
    return `
    <svg aria-hidden="true" focusable="false">
      <use href="#icon-error" />
    </svg>`
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new RegisterForm();
  });
} else {
  new RegisterForm();
}
